<app-compose-mail appendTo='body' style="z-index: 9999999;"></app-compose-mail>

<app-client-list-dialog (onHideDialog)='onHideImporter()' [visible]="visibleImporter"></app-client-list-dialog>


<p-overlayPanel appendTo="body" [showCloseIcon]="true" #op [dismissable]="false">




  <div class="row">

    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
      <mat-form-field style="width: 100% ;  ">
        <mat-select [(ngModel)]="socifact" placeholder="Billing Company Name">
          <mat-option [value]="''">
            All
          </mat-option>
          <mat-option *ngFor="let item of socifacts | async" [value]="item.raisonSocial">
            {{item.raisonSocial}}
          </mat-option>
        </mat-select>

      </mat-form-field>


      

      <mat-form-field style="width: 100% ;  ">
        <mat-select [(ngModel)]="stranger" placeholder="Pays">
          <mat-option [value]="''">
            All
          </mat-option>
          <mat-option [value]="'alg'">
            Algérie
          </mat-option>
          <mat-option [value]="'strang'">
            Etranger
          </mat-option>

        </mat-select>

      </mat-form-field>
      <mat-form-field style="width: 100% ;  ">
        <mat-select [(ngModel)]="status" placeholder="Status">
          <mat-option [value]="''">
            All
          </mat-option>

          <mat-option [value]="'pas'">
            Pas encore contacté
          </mat-option>


          <mat-option [value]="'Confirmé'">
            Confirmé
          </mat-option>
          <mat-option [value]="'En Attente  Ctr'">
            En Attente Ctr
          </mat-option>
          <mat-option [value]="'Accord Verbal'">
            Accord Verbal
          </mat-option>
          <mat-option [value]="'Négociation'">
            Négociation
          </mat-option>
          <mat-option [value]="'À relancer'">
            À relancer
          </mat-option>
          <mat-option [value]="'Devis'">
            Devis
          </mat-option>
          <mat-option [value]="'Rendez-Vous'">
            Rendez-Vous
          </mat-option>
          <mat-option [value]="'Rien a faire'">
            Rien a faire
          </mat-option>

        </mat-select>

      </mat-form-field>










      <mat-form-field style="width: 100% ;  ">
        <mat-select [(ngModel)]="pavillon" placeholder="Pavillon">
          <mat-option [value]="''">
            All
          </mat-option>
          <mat-option [value]="'France'">
            France
          </mat-option>
          <mat-option [value]="'Chine'">
            Chine
          </mat-option>
          <mat-option [value]="'Russe'">
            Russe
          </mat-option>
        </mat-select>

      </mat-form-field>
      <mat-form-field style="width: 100%">
        <mat-select placeholder="Langue" [(value)]="selectedLangue">
          <mat-select-trigger>

            <div>
              <div style="float: left;">
                <img width="15" [src]="'assets/img/'+selectedLangue+'.png'" alt="">
              </div>
              <div style="float: left;">
                <div> {{ selectedLangue  | uppercase}} </div>
              </div>
            </div>

          </mat-select-trigger>
          <mat-option *ngFor="let item of languages" [value]="item.value">
            <img width="20" [src]="'assets/img/'+item.value+'.png'" alt="">
            {{ item.value | uppercase}} - {{ item.label}}
          </mat-option>
        </mat-select>
      </mat-form-field>




    </div>

<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">

  <p-autoComplete [(ngModel)]="selectedStaff"  [suggestions]="filteredStaffs"   [dropdown]="true"
  (completeMethod)="filterCountry($event)" field="nom" [minLength]="1"></p-autoComplete> 
   <button mat-icon-button (click)="xxxxx();op.hide()">
    <mat-icon class="mat-18">search</mat-icon>Search
  </button>

<div style="margin-top: 200px;" ></div>
<button (click)="visibleImporter=true"  class="btn btn-danger" >Importer prospects</button>
  <button (click)="confirm();op.hide()" *ngIf="currentUser.roleUser.includes('admin')"  style="background-color: #E30613;color: #FFF4E9;" mat-button>Supprimer</button>
  <button (click)="confirmer();op.hide()"  style="background-color: #E30613;color: #FFF4E9;" mat-button>Confirmer</button>

  
</div>

  </div>






  <button mat-icon-button (click)="xxxxx();op.hide()">
    <mat-icon class="mat-18">search</mat-icon>Search
  </button>

</p-overlayPanel>

<mat-drawer-container class="example-container">



  <mat-drawer mode="side" style="background-color: #FFF4E9; " opened>



    <div layout="row" style="margin-left: 10px;" layout-align="space-between center" flex
      class="layout-align-space-between-center layout-row flex">
      <div style=" width: 100%;margin-top: 20px;margin-bottom: 24px;margin-left: 10px;">



        <input style="border: none;width: 60%;height: 35px;" (keyup)="applyFilter($event.target.value)"
          placeholder="Search {{listType}}">


        <button (click)="addClient( )" mat-menu-item>
          <mat-icon>add</mat-icon>

        </button>


        <button mat-icon-button (click)="op.show($event, actualTarget)" style="margin-left:5px;">
          <mat-icon matBadge="{{nbrRecords}}" matBadgeColor="warn" class="mat-18">filter_list</mat-icon>
        </button>
   <span *ngIf="!loadingPrint">
    <button *ngIf="currentUser.roleUser.includes('admin')" mat-icon-button (click)="printParticipants( )">
      <mat-icon class="mat-18">print</mat-icon>
    </button>
   </span>
<span *ngIf="loadingPrint">
  <p-progressSpinner   [style]="{width: '30px', height: '30px' ,margin: '0px 10px'}" ></p-progressSpinner>
</span>
    


      </div>




    </div>

    <div class="basic-container mat-elevation-z2" style="width: 350px;margin-left: 20px;max-height: 80vh;overflow: auto">
 
      <table mat-table [dataSource]="dataSource" style="overflow: scroll;;" matSort matSortActive="id"
        matSortDirection="desc" matSortDisableClear>


        <ng-container matColumnDef="text1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Raison Social</th>
          <td mat-cell *matCellDef="let exhibitor" style="width: 350px;padding-bottom: 2mm;padding-top: 2mm;">


            <div style="display: flex;align-items: center;">
              <div> {{exhibitor.text1 | uppercase}} {{exhibitor.text3 | uppercase}} </div>
              <div [ngStyle]="{'background-color': exhibitor.text5}" class="bulle"> </div>
            </div>




          </td>
        </ng-container>



        <tr mat-header-row *matHeaderRowDef="['text1']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['text1'];  let i= index;" style="cursor: pointer;"
          (click)="selectRow(row)" [style.font-weight]="row.l1 === selectedClientId ? 'bolder' : ''"
          [style.background-image]="row.l1 === selectedClientId ? 'url(../../assets/img/listclient.png)' : ''">
        </tr>

      </table>

    </div>





  </mat-drawer>
  <mat-drawer-content *ngIf="selectedClient" style="background-color: #FFF4E9; margin: 0px!important; ">

    <div class="row">
      <div style="height: 70px;background: #FDE2C2;text-align: center;margin-left:50px ;
            color: #2C3F91;font-size: 16px;font-weight: bold;" class='col-xs-2 col-sm-2 col-md-2 col-lg-2 '>
        <div class='middle-div' style="background: #FDE2C2;text-align: center;">
          Fiche Prospect {{clientType}}
        </div>
      </div>



      <div style="height: 70px;" class='col-xs-9 col-sm-9 col-md-9 col-lg-9 '>
        <div class='middle-div' style="color: #E30613;font-size: 16px;font-weight: bold;">
          {{selectedClient.prospectId.raisonSocial}}
    
     
        </div>
        <span   style="color: #1B2B6C;font-size: 11px;float: right;">
          -{{selectedClient.prospectId.utilisateurs.nom}}</span>
   
      </div>






    </div>
    <div style="height: 50px;background-color: #E1F3FE;margin-bottom: 20px;">


      <div style="margin-left: 40px;padding: 5px;color: #2F4395;font-weight: bold;cursor: pointer;float: left;">

        <span *ngIf="!loadingProforma" (click)="printInvoice()" style="margin-right: 50px;">
          <img src="../assets/img/invoice.png" width="40" alt="">
          Imprimer Proforma
 
        </span>


      
      <span *ngIf="loadingProforma">
        <p-progressSpinner   [style]="{width: '30px', height: '30px' ,margin: '0px 10px'}" ></p-progressSpinner>
      </span>



        <span>
          <img src="../assets/img/{{selectedClient.prospectId.langue}}.png" height="30" width="30" alt="">
          <span *ngIf="selectedClient.prospectId.langue==='fr'">Français</span>
          <span *ngIf="selectedClient.prospectId.langue==='en'">English</span>

          <span 
            style="color: #263A8F;font-size: 12px;position: absolute;top: 10px;right: 300px;max-width: 400px;max-height: 50px;overflow-x: scroll;">
            {{selectedClient.observation}} </span>

        </span>

      </div>






      <div style="margin-left: 40px;padding: 5px;color: #2F4395;font-weight: bold;cursor: pointer;float: right;">

        <span (click)="optype.show($event, actualTarget)" style="margin-right: 50px;">


          Changer Type
        </span>
        <span (click)="opstatus.show($event, actualTarget)" style="margin-right: 50px;">


          Changer Status
        </span>

        <span (click)="visibleUsers=true" *ngIf="currentUser.roleUser.includes('admin')" style="margin-right: 50px;">

          Basculer

        </span>





        <span (click)="gotoLogistiques(4)">
          <img src="../assets/img/email.png" width="40" alt="">
          Envoyer un email

        </span>





      </div>
    </div>



    <div class="row" style="margin-left: 20px;margin-right:20px;background-color:  #FFF4E9;" *ngIf="selectedClient">


      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <app-personel-client [selectedClient]='selectedClient'></app-personel-client>
      </div>

      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <app-contacts-client [contactForm]='contactForm'></app-contacts-client>
      </div>
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <app-other-options></app-other-options>
      </div>

    </div>

    <div class="row" style="margin: 20px;background-color: #FFF4E9;" *ngIf="selectedClient">
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <app-stands-client [idClient]="selectedClientId"></app-stands-client>
      </div>
      <div *ngIf="this.selectedClient.type=='ES' || this.selectedClient.type=='S'  " class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <app-package-sponsor  [prospect]='selectedClient.prospectId'></app-package-sponsor>
      </div>

         <div *ngIf="false" class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <app-note-client  [selectedClient]='selectedClient'></app-note-client>
        </div>


    </div>



    <div style="height: 50px;background-color: #E1F3FE;margin-bottom: 20px;">









    </div>








  </mat-drawer-content>
</mat-drawer-container>

<app-dialog-user-lists [visibleUsers]='visibleUsers' (select)='basculer($event)'></app-dialog-user-lists>

<p-overlayPanel appendTo="body" #opstatus [dismissable]="true">

  <div (click)="changeStatus('Confirmé','#5DFF5D');opstatus.hide()"
    style="display: flex; align-items: center;cursor: pointer;">
    <div style=" background-color: #5DFF5D;" class="bulle"></div>
    <div>Confirmé</div>
  </div>

  <div (click)="changeStatus('En Attente  Ctr','#82A971');opstatus.hide()"
    style="display: flex; align-items: center;cursor: pointer;">
    <div style=" background-color: #82A971;" class="bulle"> </div>
    <div> En Attente Ctr</div>
  </div>

  <div style="display: flex; align-items: center;cursor: pointer;"
    (click)="changeStatus('Accord Verbal','#6AA84F');opstatus.hide()">

    <div style=" background-color: #6AA84F;" class="bulle"> </div>
    <div>Accord Verbal </div>
  </div>

  <div style="display: flex; align-items: center;cursor: pointer;"
    (click)="changeStatus('Négociation','#7B94AC');opstatus.hide()">
    <div style=" background-color: #7B94AC;" class="bulle"> </div>
    <div>Négociation </div>
  </div>

  <div style="display: flex; align-items: center;cursor: pointer;"
    (click)="changeStatus('À relancer','#990000');opstatus.hide()">
    <div style=" background-color: #990000;" class="bulle"> </div>
    <div>À relancer </div>
  </div>

  <div style="display: flex; align-items: center;cursor: pointer;"
    (click)="changeStatus('Devis','#FFAC2F');opstatus.hide()">
    <div style=" background-color: #FFAC2F;" class="bulle"> </div>
    <div> Devis </div>
  </div>

  <div style="display: flex; align-items: center;cursor: pointer;"
    (click)="changeStatus('Rendez-Vous','#0000FF');opstatus.hide()">
    <div style=" background-color: #0000FF;" class="bulle"> </div>
    <div> Rendez-Vous </div>
  </div>

  <div style="display: flex; align-items: center;cursor: pointer;"
    (click)="changeStatus('Rien a faire','#DE5A5A');opstatus.hide()">

    <div style=" background-color: #DE5A5A;" class="bulle"> </div>
    <div>Rien a faire </div>
  </div>

</p-overlayPanel>

<p-overlayPanel appendTo="body" #optype [dismissable]="true">

  <div *ngFor="let typeClient of typeClients" (click)="changerType(typeClient.value);optype.hide()"
    style="display: flex; align-items: center;cursor: pointer;">
 
    <div style="border-bottom: 1px solid orange;width: 100%;">{{typeClient.label}}</div>
  </div>
 

 

</p-overlayPanel>




<p-dialog *ngIf="selectedClient" header="Archiver exposant" [style]="{width: '400px', minWidth: '300px'  }"
  [(visible)]="visibleArchiver">


  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      Client: <b>{{selectedClient.raisonSocial}}</b>

    </div>
    <br>
  </div>


  <div class="row">

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">

      <textarea rows="5" [(ngModel)]="selectedClient.observation" style="width: 100%;" pInputTextarea></textarea>

    </div>


  </div>

  <p-footer>
    <p-button icon="pi pi-select" (click)="archiver()" [style]="{'color': 'white','background-color': 'red'} "
      label="Archiver"></p-button>
  </p-footer>
</p-dialog>







 